export const defaultCookieParams = {
  expirationDate: 7, // days
};

export const motifs = ['rdv', 'programme', 'testeligibilite'];

//! CLEANUP
// utilisé ?
// export const fromCookie = (key) => {
//   let output = {};
//   document.cookie.split(/\s*;\s*/).forEach(function (pair) {
//     pair = pair.split(/\s*=\s*/);
//     output[pair[0]] = pair.splice(1).join('=');
//   });

//   if (key) {
//     return output[key];
//   }

//   return output;
// };


//! TODO USE THIS VERSION AS IT DOESNT REQUIRE TO RELOAD THE PAGE AND CAN STILL SEND UTMS AND IDENTIFIERS IN REQUEST
export const createSessionAndRetrieveTokensV2 = () => {
  let cookiesUTM = {};
  // retourne ?aa=bbb
  const currentUrlSP = new URLSearchParams(window.location.search);
  let url = global.window?.location?.href;
  let autofill_parameters = '';
  let ga_cid;

  // Get SESSION_ANONYME value
  cookiesUTM.session_anonyme = getCookieValueFromHisName(
    '_PHP_SESSION_ANONYME'
  );

  // Get GA_CID
  let ga_cid_full = getCookieValueFromHisName('_ga');
  let ga_cid_array = ga_cid_full.split('.');
  ga_cid = ga_cid_array[2] + '.' + ga_cid_array[3];

  cookiesUTM.ga_cid = ga_cid;

  // Get FB Cookies
  cookiesUTM.fb_fbc = getCookieValueFromHisName('_fbc');
  cookiesUTM.fb_fbp = getCookieValueFromHisName('_fbp');

  // set gclid cookie
  setCookie('gclid', getUrlParam('gclid'), 90);

  // pour chaqun des 3 motifs
  motifs.forEach((motif) => {
    // si on a le motif dans la liste des queryParams en GET
    if (currentUrlSP.get(motif)) {
      // création du cookie, ex : motif=rdv;max-age=3600;domain=lecolefrancaise.fr;path=/
      document.cookie =
        'motif=' +
        motif +
        ';max-age=' +
        60 * 60 +
        ';domain=lecolefrancaise.fr;path=/'; // TODO : rendre dynamique l'url du domain pour le cookie

      // création du cookie qui valide le motif choisi, doublon ? ( rdv=1;max-age=3600;domain=lecolefrancaise.fr;path=/)
      document.cookie =
        motif + '=1;max-age=' + 60 * 60 + ';domain=lecolefrancaise.fr;path=/';
    }
  });

  return cookiesUTM;
};

export function setCookie(
    cookieName,
    cookieValue,
    expirationDays = defaultCookieParams.expirationDate,
    path = '/',
){
  const d = new Date();
  d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=" + path;
}

export function getUrlParam(param) {
  let match = RegExp('[?&]' + param + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function getCookieValueFromHisName(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(global.window.document.cookie);
  let ca = decodedCookie.split(';');

  // on parcout le tableau des cookie (contenant par ex:  _PHP_SESSION_ANONYME=16780961 )
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    // gestion de l'espace en début de cookie name
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    // on ne retourne que le cookie qui nous interesse ( cname )
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
